import React from 'react' ; 
import { Link as RouterLink} from 'react-router-dom' ;

function CardItem(props){
    return(
        <li className="cards_item">
            <RouterLink className="cards_item_link" to={props.path}>
                <figure className="cards_item_pic_wrap "> 
                    <img src={props.src} height="50px" alt={props.alt} className="cards_item_img" />
                </figure>
                <div className="cards_items_info" id="info">
                    <h5 className="cards_item_text">{props.text}</h5>
                    <h4 className="cards_item_content">{props.content}</h4>
                </div>
            </RouterLink>
        </li>
    )
}



export default CardItem